// Angular
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';
// RxJS
import 'rxjs';
// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...
//import 'angular2-color-picker/lib';

// Font
//import '../public/css/proxima-nova/proxima-nova.css';
import 'font-awesome/css/font-awesome.min.css';

// plugin css
import '../public/css/bootstrap.min.css';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/themes/material_green.css';
// import '../public/plugin/flatpickr/final/flatpickr.min.css';
// import '../public/plugin/flatpickr/final/themes/material_green.css';
import 'fullcalendar/dist/fullcalendar.min.css';
import '../node_modules/slim-select/dist/index.css';

// custom css
import '../public/css/login-module.css';
import '../public/css/ui-custom.css';
import '../public/css/ui-skin-colors.css';
import '../public/css/global.css';
import '../public/css/driver.css';


// import 'moment/min/moment.min.js';
// import 'jquery/dist/jquery.min.js';
// import 'flatpickr/dist/flatpickr.min.js';
// import 'fullcalendar/dist/fullcalendar.min.js';
// import 'fullcalendar/dist/locale-all.js';

// import '//cdn.tinymce.com/4/tinymce.min.js';
// import '//maps.googleapis.com/maps/api/js?key=AIzaSyBBeomV-g_vhhz4fK0kIunxuQGSWBeK1Sg&libraries=places';






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/vendor.ts